import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ArrowUpRight, Menu, X } from "lucide-react";
import logo from "../assets/the-bryan-residences-logo.png";
import "./Layout.css";

const navItems = [
  ["Home", "/"],
  ["Stays", "/accommodation"],
  ["Our story", "/about"],
  ["Services", "/services"],
  ["Guest stories", "/testimonials"],
  ["FAQ", "/faq"],
  ["Contact", "/contact"],
];

const navClass = ({ isActive }) =>
  `header__link${isActive ? " header__link--active" : ""}`;

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header-wrap">
      <div className="header container">
        <Link
          className="header__brand"
          to="/"
          onClick={closeMenu}
          aria-label="The Bryan Residence home"
        >
          <img
            className="header__logo-image"
            src={logo}
            alt="The Bryan Residences"
          />
        </Link>
        <nav className="header__nav" aria-label="Primary navigation">
          {navItems.map(([label, to]) => (
            <NavLink end={to === "/"} className={navClass} to={to} key={to}>
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="header__actions">
          {/* <Link className="header__login" to="/testimonials">
            Guest stories
          </Link> */}
          <NavLink className="header__book" to="/accommodation">
            Book a stay <ArrowUpRight size={13} />
          </NavLink>
          <button
            className="header__menu"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation"
            aria-expanded={menuOpen}
          >
            {menuOpen ? <X size={19} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      <nav
        className={`header__mobile-nav${menuOpen ? " header__mobile-nav--open" : ""}`}
        aria-label="Mobile navigation"
      >
        <nav
          className={`header__mobile-nav${
            menuOpen ? " header__mobile-nav--open" : ""
          }`}
          aria-label="Mobile navigation"
        >
          {navItems.map(([label, to]) => (
            <NavLink
              end={to === "/"}
              className={navClass}
              onClick={closeMenu}
              to={to}
              key={to}
            >
              {label}
              <ArrowUpRight size={16} />
            </NavLink>
          ))}
        </nav>
      </nav>
    </header>
  );
}

const footerColumns = [
  {
    title: "Explore",
    links: [
      ["Find a stay", "/accommodation"],
      ["Our story", "/about"],
      ["Thoughtful services", "/services"],
      ["Guest stories", "/testimonials"],
    ],
  },
  {
    title: "Stay informed",
    links: [
      ["Common questions", "/faq"],
      ["Contact our team", "/contact"],
      ["Private offers", "/accommodation"],
      ["Accessibility", "/faq"],
    ],
  },
];

export function Footer() {
  return (
    <footer className="footer">
      <section className="footer__statement container">
        <div className="footer__statement-copy">
          <p className="eyebrow">Luxury, intelligently lived</p>
          <h2>
            Luxury holiday living,
            <br />
            made beautifully
            <br />
            <em>effortless.</em>
          </h2>
        </div>
        <div className="footer__statement-note">
          <span>01 — The Bryan Residence</span>
          <p>
            Luxury automated holiday apartments designed for extraordinary stays
            in the heart of Lekki Phase 1.
          </p>
          <Link to="/about">
            Discover the residence <ArrowUpRight size={15} />
          </Link>
        </div>
        <div className="footer__statement-seal">
          <img src={logo} alt="The Bryan Residences" />
          <small>
            Luxury stays
            <br />
            in Lekki Phase 1
          </small>
        </div>
      </section>
      <div className="footer__main">
        <div className="footer__grid container">
          <div className="footer__about">
            <Link className="footer__brand" to="/">
              <img src={logo} alt="The Bryan Residences" />
            </Link>
            <p>
              Luxury Automated Holiday Apartments Designed for Extraordinary
              Stays. 42 Olanrewaju Ninalowo Crescent, Lekki Phase 1, Lagos,
              Nigeria.
            </p>
            <div>
              <a
                href="https://www.instagram.com/thebryanresidence?igsh=MWZyNGkzN2pid3Iybg=="
                aria-label="Instagram"
                className="footer__social-letter"
                target="_blank"
              >
                ig
              </a>
            </div>
          </div>
          {footerColumns.map((column) => (
            <div className="footer__column" key={column.title}>
              <h3>{column.title}</h3>
              {column.links.map(([label, to]) => (
                <Link to={to} key={label}>
                  {label}
                  <ArrowUpRight size={12} />
                </Link>
              ))}
            </div>
          ))}
        </div>
        <div className="footer__bottom container">
          <span>
            © {new Date().getFullYear()} The Bryan Residence. All Rights
            Reserved.
          </span>
          <div>
            <a href="#privacy">Privacy</a>
            <a href="#terms">Terms</a>
            <a href="#cookies">Cookies</a>
          </div>
          <a href="#top" className="footer__top">
            Back to top ↑
          </a>
        </div>
      </div>
    </footer>
  );
}

export function PageShell({ children }) {
  return (
    <div className="page" id="top">
      <Header />
      {children}
      <Footer />
    </div>
  );
}
